import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/api';
import { CommessaService } from '../services/commessa.service';
import { AlertUtil } from '../utils/alert-util';
import { DragDropModule } from 'primeng/dragdrop';
import { IGruppo } from '../interfaces/IGruppo';
import { Loading } from '../utils/loading';
import { RequestBuilder } from '../classes/request-builder';
import { finalize } from 'rxjs/operators';
import { GruppoService } from '../services/gruppo.service';
import { ICommessa } from '../interfaces/ICommessa';

@Component({
  selector: 'app-associa-commessa-agruppo-modal',
  templateUrl: './associa-commessa-agruppo-modal.component.html',
  styleUrls: ['./associa-commessa-agruppo-modal.component.css']
})
export class AssociaCommessaAGruppoModalComponent implements OnInit {

  data: any

  availableCommesse: ICommessa[];
  selectedCommesse: ICommessa[];
  draggedCommessa: ICommessa;

  gruppi: IGruppo[]
  selectedGruppo: IGruppo

  constructor(private formBuilder: FormBuilder,
    private ref: DynamicDialogRef,
    private config: DynamicDialogConfig,
    private gruppoService: GruppoService,
    private commessaService: CommessaService,
    private alertUtil: AlertUtil) {
    this.availableCommesse = this.config.data.commesse
    setTimeout(() => {
      this.getAllGruppi()
    }, 0);
  }

  ngOnInit() {
    this.selectedCommesse = [];
  }

  dragStart(event, any: any) {
    this.draggedCommessa = any;
  }

  drop(event) {
    if (this.draggedCommessa) {
      let draggedanyIndex = this.findIndex(this.draggedCommessa);
      this.selectedCommesse = [...this.selectedCommesse, this.draggedCommessa];
      this.availableCommesse = this.availableCommesse.filter((val, i) => i != draggedanyIndex);
      this.draggedCommessa = null;
    }
  }

  dragEnd(event) {
    this.draggedCommessa = null;
  }

  findIndex(commessa: ICommessa) {
    let index = -1;
    for (let i = 0; i < this.availableCommesse.length; i++) {
      if (commessa.Id === this.availableCommesse[i].Id) {
        index = i;
        break;
      }
    }
    return index;
  }

  /**
   * fetch gruppi
   */
  getAllGruppi() {
    Loading.isLoading = true
    let reqBuilder = new RequestBuilder({})
    this.gruppoService.getAllGruppi(reqBuilder).pipe(finalize(() => {
      Loading.isLoading = false
    })).subscribe(
      response => {
        if (response.data) {
          this.gruppi = response.data
        }
        else if (response.error) {
          let errorKey = "LBL_ERROR_" + response.error.Code
          this.alertUtil.showErrorAlert(errorKey)
          console.log("ERROR: " + response.error.Stack)
        }
        else {
          this.alertUtil.showErrorAlert("LBL_SERVER_ERROR_GENERIC", { error: response.Message })
        }
      },
      error => {
        let errorKey = "LBL_HTTP_ERROR_0"
        if (error.status) {
          errorKey = "LBL_HTTP_ERROR_" + error.status
        }
        this.alertUtil.showErrorAlert(errorKey)
      })
  }

  onSave() {
    //TODO
    //Chiamata a servizio che associa delle commesse ad un gruppo
    // this.selectedCommesse
    // this.selectedGruppo
  }

}
